import { render, staticRenderFns } from "./Profile4User.vue?vue&type=template&id=21c89efc&scoped=true&"
import script from "./Profile4User.vue?vue&type=script&lang=js&"
export * from "./Profile4User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__lodash@_un4jhf4odrklsfexjnq27ps2iu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c89efc",
  null
  
)

export default component.exports